<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="70%"
    title="收款记录确认"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <div>
        <jr-label title="订单信息" />
        <el-row :gutter="20">
          <el-col :span="12">
            <data-show label="业务订单编号：">
              <jr-tooltip :content="receiptObj.orderNumber" type="popover" />
            </data-show>
          </el-col>
          <el-col :span="12">
            <data-show label="收款金额：">
              {{ receiptObj.receiptAmount | toFenThousandsAndFloat('¥') }}
            </data-show>
          </el-col>
          <el-col :span="12">
            <data-show label="客户编号：">
              {{ receiptObj.recBusinessNo || "-" }}
            </data-show>
          </el-col>
          <el-col :span="12">
            <data-show label="客户名称：">
              {{ receiptObj.recBusinessName || "-" }}
            </data-show>
          </el-col>
        </el-row>
      </div>
      <div class="list">
        <jr-label title="到账流水记录" />
        <div class="total-money">
          <el-input
            v-model="amount"
            placeholder="请输入"
            size="small"
            v-on:blur="setAmount($event)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchAmount"
            ></el-button>
          </el-input>
          <div>
            <span>*</span> 已勾选金额：
            {{ currentSelectItem.amount | toFenThousandsAndFloat }}
            元
          </div>
        </div>
        <jr-table
          size="small"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
          :search-params.sync="tableQuery"
          :pagination="true"
          :total="total"
          @refresh="refreshList"
          :height="300"
        >
          <template v-slot:selectRow="{ row }">
            <el-checkbox v-model="row.checked" @change="selectedChange(row)" />
            {{ "" }}
          </template>
        </jr-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize">取消</el-button>
      <el-button
        type="primary"
        :size="formSize"
        @click="submit()"
        :loading="submitLoading"
      >
        提交
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getBookFlowList, setReceiptOper } from '@/api/receivables/receipt';
import { regFenToYuan, regYuanToFen, formatFloat } from '@/utils/number';
import { amountValidator } from '@/utils/validate';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    receiptObj: {
      type: Object,
      default: () => ({}),
    },
    receiptNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitLoading: false,
      loading: false,
      tableQuery: {
        page: 1,
        limit: 10,
      },
      total: 0,
      list: [],
      tableColumn: [
        { label: '', slotName: 'selectRow', minWidth: '40', align: 'center' },
        { label: '收款账号', prop: 'accountNo', minWidth: '100' },
        { label: '渠道流水号', prop: 'orderNo', minWidth: '100' },
        { label: '到账时间', prop: 'finishTime', filterName: 'formatTime', minWidth: '100' },
        { label: '到账金额(元)', prop: 'amount', filterName: 'toFenThousandsAndFloat', minWidth: '100' },
        { label: '付款户名', prop: 'payerAccountName', minWidth: '100' },
        { label: '付款账号', prop: 'payerAccountNo', minWidth: '100' },
        { label: '备注', prop: 'remark', minWidth: '100' },
      ],
      currentSelectItem: {},
      searchParams: {},
      amount: 0, // 金额搜索
      isSearch: false,
    };
  },
  methods: {
    // tab切换
    handleTabsClick() {
      this.$refs.ruleForm.resetFields();
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.tableQuery = {
        page: 1,
        limit: 10,
      };
      this.total = 0;
      this.list = [];
      this.currentSelectItem = {};
      this.submitLoading = false;
      this.loading = false;
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.amount = regFenToYuan(this.receiptObj.receiptAmount ?? 0).toFixed(2);
        this.isSearch = false;
        this.getList('');
      });
    },
    // 根据金额搜索
    searchAmount() {
      this.isSearch = true;
      const amount = !this.amount ? '' : regYuanToFen(this.amount);
      this.getList(amount);
    },
    async getList(amount) {
      try {
        this.loading = true;
        const res = await getBookFlowList({
          receiptNo: this.receiptNo,
          amount,
          ...this.tableQuery,
        });
        const { data, totalCount } = res;
        data.forEach((item) => {
          item.checked = false;
        });
        this.list = data;
        this.total = totalCount;
      } finally {
        this.loading = false;
      }
    },
    // 刷新列表
    refreshList(params) {
      this.tableQuery = { ...this.tableQuery, ...params };
      if (this.isSearch) {
        this.searchAmount();
      } else {
        this.getList();
      }
    },
    selectedChange(row) {
      this.list.forEach((item) => {
        if (item.flowNo !== row.flowNo) {
          item.checked = false;
        }
      });
      this.currentSelectItem = row.checked ? row : {};
    },
    // 提交
    async submit() {
      if (!this.currentSelectItem.flowNo) {
        this.$message.warning('请勾选到账流水');
        return;
      }
      if (this.currentSelectItem.amount !== this.receiptObj.receiptAmount) {
        this.$message.warning('勾选的到账金额与收款金额不相等，请重新勾选');
        return;
      }
      try {
        this.submitLoading = true;
        const params = {
          receiptNo: this.receiptNo,
          flowNo: this.currentSelectItem.flowNo,
          operation: 1,
        };
        await setReceiptOper(params);
        this.$message.success('操作成功！');
        this.submitLoading = false;
        this.handleClose();
        this.$emit('success');
      } finally {
        this.submitLoading = false;
      }
    },
    setAmount(e) {
      const { value } = e.target;
      const amount = String(value).replaceAll(',', '');
      if (amountValidator(amount)) {
        this.amount = amount;
        return;
      }
      const val = amount.indexOf('.') > -1 ? formatFloat(amount.slice(0, amount.indexOf('.') + 3)) : amount;
      this.amount = val;
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
  }
  .title-text {
    font-size: 16px !important;
  }
  .total-money {
    .el-input-group__append,
    .el-button {
      padding: 0;
    }
  }
}
.list {
  margin-top: 10px;
}
.total-money {
  text-align: right;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: end;
  span {
    color: $color-red;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
}
</style>
